import { api } from '../utils/api';

export interface AIProviderInfo {
  id: 'anthropic' | 'openai' | 'gemini';
  name: string;
  keyUrl: string;
  model: string;
  configured: boolean;
  keyMasked: string | null;
}

export interface AISettings {
  active: string;
  providers: AIProviderInfo[];
}

export async function getAISettings(): Promise<AISettings> {
  const { data } = await api.get<AISettings>('/ai/settings');
  return data;
}

export async function saveAISettings(payload: {
  provider: string;
  api_key?: string;
  model?: string;
}): Promise<void> {
  await api.post('/ai/settings', payload);
}

export interface AIStatus {
  provider: string;
  status: 'connected' | 'error';
  message?: string;
}

export async function testAIConnection(): Promise<AIStatus> {
  const { data } = await api.get<AIStatus>('/ai/status');
  return data;
}

export async function generateProductDescription(
  productName: string,
  category?: string
): Promise<string> {
  const { data } = await api.post<{ description: string }>('/ai/generate-description', {
    product_name: productName,
    category,
  });
  return data.description;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export async function askAssistant(
  message: string,
  history: ChatMessage[] = []
): Promise<string> {
  const { data } = await api.post<{ reply: string }>('/ai/assistant', {
    message,
    history,
  });
  return data.reply;
}
